import { RequestType } from '../constants';
import { endpoints } from '../endpoints';
import { fetchClient } from '../fetchClient';

export async function addInterestedUser(data) {
  try {
    return await fetchClient(endpoints.addInterestedUser(), {
      type: RequestType.POST,
      body: data,
    });
  } catch (error) {
    const status = error.status;
    // eslint-disable-next-line no-throw-literal
    throw {
      status,
      message: getErrorMessageByStatus(status),
    };
  }
}

function getErrorMessageByStatus(status) {
  const map = {
    422: 'E-postadressen er allerede registrert',
  };

  return map[status] || 'An unknown error occurred';
}
